// extracted by mini-css-extract-plugin
module.exports = {"create-selection-btn":"CreateSelectionButton_create-selection-btn__36N2w"};